// extracted by mini-css-extract-plugin
export default {"address-choose-modal":"address-choose-modal-o9lXg5","confirm-modal":"confirm-modal-_Pxi4J","title":"title-kKpzVB","list":"list-fpFgiV","listItem":"listItem-h9HDya"};